import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
interface CountdownClockProps {
  variant?: 'dark' | 'light';
}
export function CountdownClock({
  variant = 'dark'
}: CountdownClockProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: 'Horas'
  }, {
    value: minutes,
    label: 'Min'
  }, {
    value: seconds,
    label: 'Seg'
  }];
  const box = variant === 'dark' ? 'bg-ink text-cream border-ink' : 'bg-paper text-ink border-line';
  const labelTone = variant === 'dark' ? 'text-ink-mute' : 'text-ink-mute';
  return <div className="flex items-start gap-3" role="timer" aria-live="off" data-id="element-52" data-mp="1j21h2039a0qh">
      {units.map((unit, index) => <React.Fragment key={unit.label} data-id="element-53" data-mp="1nztch43404zf" data-mpi={index}>
          <div className="text-center" data-id="element-54" data-mp="1o2p7oknkofk6">
            <div className={`min-w-[84px] rounded-xl border px-4 py-3 font-display text-4xl font-semibold tabular-nums sm:min-w-[104px] sm:text-5xl ${box}`} data-id="element-55" data-mp="3df160jtj07af">
              {unit.value}
            </div>
            <p className={`mt-2 text-[10px] font-semibold uppercase tracking-eyebrow ${labelTone}`} data-id="element-56" data-mp="nrc59tf1va08">
              {unit.label}
            </p>
          </div>
          {index < units.length - 1 && <span aria-hidden="true" className={`pt-3 font-display text-3xl sm:text-4xl ${variant === 'dark' ? 'text-ink/30' : 'text-ink-mute/50'}`} data-id="element-57" data-mp="wn1llo1n5e6r">
              :
            </span>}
        </React.Fragment>)}
    </div>;
}